import { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

import { TabPanel, BrowserTitle, ActivityLogsTable, AuthLogsTable, BlockedIPsTable } from '../components';

// Entity types mapping for API

// Tab configuration
const TABS = [
  { label: 'Authorization', path: '', component: 'auth', title: 'Authorization Logs' },
  { label: 'Blocked IPs', path: 'blocked', component: 'blocked', title: 'Blocked IP Addresses' },
  { label: 'Appointments', path: 'appointments', entityType: 'appointment', title: 'Appointment Activity' },
  { label: 'Clients', path: 'clients', entityType: 'client', title: 'Client Activity' },
  { label: 'Properties', path: 'properties', entityType: 'property', title: 'Property Activity' },
  { label: 'Proposals', path: 'proposals', entityType: 'proposal', title: 'Proposal Activity' },
  { label: 'Invoices', path: 'invoices', entityType: 'invoice', title: 'Invoice Activity' },
  { label: 'Items', path: 'items', entityType: null, title: 'Items Activity' },
];

function addTabIndex(index) {
  return {
    id: `logs-tab-${index}`,
    'aria-controls': `logs-tabpanel-${index}`,
  };
}

export const Logs = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);

  const tabSwitcher = (e, val) => {
    setActiveTab(val);
    const tabPath = TABS[val].path;
    navigate(tabPath ? `/logs/${tabPath}` : '/logs');
  };

  useEffect(() => {
    const tabIndex = TABS.findIndex(t => t.path === (tab || ''));
    if (tabIndex !== -1) {
      setActiveTab(tabIndex);
    } else {
      setActiveTab(0);
    }
  }, [tab]);

  return (
    <section>
      <BrowserTitle title="Activity Logs | Airmaxx Pro" />
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={tabSwitcher} aria-label="logs tabs">
            {TABS.map((tabConfig, index) => (
              <Tab
                key={tabConfig.path || 'default'}
                label={tabConfig.label}
                {...addTabIndex(index)}
                sx={{ color: '#0D3B59 !important', fontFamily: 'Lato, sans-serif' }}
              />
            ))}
          </Tabs>
        </Box>
        
        {TABS.map((tabConfig, index) => (
          <TabPanel key={tabConfig.path || 'default'} value={activeTab} index={index}>
            {tabConfig.component === 'auth' ? (
              <AuthLogsTable />
            ) : tabConfig.component === 'blocked' ? (
              <BlockedIPsTable />
            ) : (
              <ActivityLogsTable 
                entityType={tabConfig.entityType} 
                title={tabConfig.title}
              />
            )}
          </TabPanel>
        ))}
      </Box>
    </section>
  );
};
